import { render } from "./SpecialProcessPriorityTable.vue?vue&type=template&id=58c35f89&ts=true&lang=pug"
import script from "./SpecialProcessPriorityTable.vue?vue&type=script&lang=ts"
export * from "./SpecialProcessPriorityTable.vue?vue&type=script&lang=ts"

import "./SpecialProcessPriorityTable.vue?vue&type=style&index=0&id=58c35f89&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__